import {Component, inject, ViewChild} from '@angular/core';
import {PageGridComponent} from 'src/app/shared/components/page-grid/page-grid.component';
import {GridModel} from 'src/app/shared/model/page-grid';
import {FinanceFilterModel} from '../../models/finance-filter-model';
import {FinanceFilterModalService} from '../../service/finance-filter-modal.service';
import {SalesActivityTravelTypeService} from '../../service/sales-activity-travel-type.service';
import {GetTravelTypeSalesActivityReportResponse, TravelTypeSalesActivityReportResponse} from '../../models/travel-type-sales-activity-report-response';

@Component({
    selector: 'app-sales-activity-travel-type-list',
    templateUrl: './sales-activity-travel-type-list.component.html',
    standalone: false
})

export class SalesActivityTravelTypeListComponent{
  @ViewChild(PageGridComponent) protected salesActivityTravelTypeListRef!: PageGridComponent;

  constructor(
    private financeFilterModalService: FinanceFilterModalService
    ) { 
      this.financeFilterModalService.getFilters().subscribe((filter: FinanceFilterModel) => {
            const {
                TravelTypeIds,
                SubmitToList,
                IssueDateFrom,
                IssueDateTo,
                DataSourceId,
                BranchIds,
                ReloadGrid
            } = filter;

            this.travelTypeGrid.filtersInitial = {
                TravelTypeIds,
                SubmitToList,
                IssueDateFrom: new Date(IssueDateFrom).toISOString(),
                IssueDateTo: new Date(IssueDateTo).toISOString(),
                DataSourceId,
                BranchIds,
                ReloadGrid
            }

            if(filter.ReloadGrid) {
              this.salesActivityTravelTypeListRef?.getItems();
            }
          });
    }

  protected readonly travelTypeGrid: GridModel<GetTravelTypeSalesActivityReportResponse> = {
    gridDataTestId: 'sales-activity-report-travel-type-list',
    gridTitle: 'Sales Activity Report - Travel Type',
    defaultPageSize: 15, 
    replayButton: true,
    singleColumnFilter: true,
    columns: [
      {
        columnProperty: 'travelTypeName',
        columnHeader: 'Travel Type',
        sort: true,
        clickable: false,
      },
      {
        columnProperty: 'travelTypePercentToTotalFare',
        columnHeader: '% Total',
        sort: true,
        columnPropertyFunction: (item: TravelTypeSalesActivityReportResponse) => `${item.travelTypePercentToTotalFare ?? ''}`,
      },
      {
        columnProperty: 'travelTypePercentYield',
        columnPropertyFunction: (item: TravelTypeSalesActivityReportResponse) => `${item.travelTypePercentYield ?? ''}`,
        columnHeader: '% Yield',
        sort: true,
      },
      {
        columnProperty: 'travelTypeTotalFareSum',
        columnPropertyFunction: (item: TravelTypeSalesActivityReportResponse) => `${item.travelTypeTotalFareSum ?? ''}`,
        columnHeader: 'Total Fare',
        sort: true,
      },
      {
        columnProperty: 'travelTypeNetFareSum',
        columnHeader: 'Net Fare',
        sort: true,
      },
      {
        columnProperty: 'travelTypeCommAmountSum',
        columnHeader: 'Commission',
        sort: true,
      },
      {
        columnProperty: 'travelTypePercentComm',
        columnHeader: '% Comm',
        sort: true,
      },
    ],
    gridGetService: inject(SalesActivityTravelTypeService)
  };
}